import { render, staticRenderFns } from "./UserRecycle.vue?vue&type=template&id=c12d31f4&scoped=true"
import script from "./UserRecycle.vue?vue&type=script&lang=js"
export * from "./UserRecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d31f4",
  null
  
)

export default component.exports